export default __webpack_public_path__ + "static/media/guess number.775b2a27.png";